import React from 'react';
import { useMutation } from 'react-apollo';
import ToastHelper from '../../helpers/ToastHelper';
import EasyEdit from 'react-easy-edit';
import { UPDATE_ONE_PAYMENT_TYPE } from '../../graphql/mutation';

function PaymentTypeItem(props) {

    const { paymentType } = props;

    const [isActive, setIsActive] = React.useState(false)

    const [updateOnePaymentType] = useMutation(UPDATE_ONE_PAYMENT_TYPE);

    React.useEffect(() => {
        if (paymentType) {
            setIsActive(paymentType.node.isActive)
        }
    }, [paymentType])

    return (
        <React.Fragment>
            <tr className="font-size-13 payment-item">
                <td className="relative">
                    <div>{paymentType.node.code}</div>
                </td>
                <td className="relative">
                    <EasyEdit
                        value={paymentType.node.name}
                        type="text"
                        onSave={(value) => {
                            updateOnePaymentType({
                                variables: {
                                    input: {
                                        update: {
                                            name: value
                                        },
                                        id: paymentType.node.id
                                    }
                                }
                            }).catch(e => {
                                ToastHelper.toggleToast({
                                    toastType: "error",
                                    message: e,
                                    title: "",
                                    onClick: function () { }
                                })
                            }).then(val => {
                                if (val) {
                                    ToastHelper.toggleToast({
                                        message: "Update Succesfully!",
                                        title: "",
                                        onClick: function () { }
                                    })
                                }
                            })
                        }}
                        saveButtonLabel={<i className="mdi mdi-check font-size-16 align-middle"></i>}
                        cancelButtonLabel={<i className="mdi mdi-close font-size-16 align-middle"></i>}
                        saveButtonStyle="easy-edit-button-save"
                        cancelButtonStyle="easy-edit-button-cancel"
                    />
                </td>
                <td className="relative">
                    <div className="custom-control custom-switch mb-2" dir="ltr">
                        <input type="checkbox" className="custom-control-input pointer" id="customSwitch1" checked={isActive} />
                        <label className="custom-control-label pointer" htmlFor="customSwitch1" onClick={() => {
                            let newVal = !isActive
                            setIsActive(newVal)
                            updateOnePaymentType({
                                variables: {
                                    input: {
                                        update: {
                                            isActive: newVal
                                        },
                                        id: paymentType.node.id
                                    }
                                }
                            }).catch(e => {
                                ToastHelper.toggleToast({
                                    toastType: "error",
                                    message: e,
                                    title: "",
                                    onClick: function () { }
                                })
                            }).then(val => {
                                if (val) {
                                    ToastHelper.toggleToast({
                                        message: "Update Succesfully!",
                                        title: "",
                                        onClick: function () { }
                                    })
                                }
                            })
                        }}>
                        </label>
                    </div>
                </td>
            </tr>
        </React.Fragment >
    );
}

export default PaymentTypeItem;